/**
 * Find matching legacy metric by experience name and type
 */
export function findMatchingLegacyMetric(interaction, experienceName) {
  var _interaction$legacyMe;
  return (_interaction$legacyMe = interaction.legacyMetrics) === null || _interaction$legacyMe === void 0 ? void 0 : _interaction$legacyMe.find(function (metric) {
    return (metric.key === experienceName || metric.config.reactUFOName === experienceName) && metric.type === 'PAGE_LOAD';
  });
}